const preRollContainerTemplate = ({preRollSizeClass, preRollSrc}) => `<iframe id="pre_roll_container" class="preRoll preRollHidden ${preRollSizeClass}" src="${preRollSrc}" scrolling="no"  frameborder="0"></iframe>`;

export default preRollContainerTemplate;
